import React from "react";
import { Table, Button, Tooltip } from "antd";
import { PlusOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faEye, faClockRotateLeft, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { ProhibitedArea } from "components";
import FlexContainerLayout from "components/atoms/FlexContainerLayout";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Column } = Table;
const keyTypesMap = {
    'GOOGLE_MAP_KEY': 'Google Maps',
    'OPEN_AI_KEY': 'Open AI',
    'AZURE_OPENAI_KEY': 'Azure OpenAI',
    'ANTHROPIC_KEY': 'Anthropic (Claude)',
    'AWS_BEDROCK_KEY': 'AWS Bedrock',
    'CUSTOM_LLM_KEY': 'Customer-hosted',
};

const KeysList = ({
    keyList,
    onCreateNewKey,
    onEditKey,
    onDeleteKey,
    onViewKey,
    onShowHistory,
    permission
}) => {
    if (!permission) {
        return <ProhibitedArea></ProhibitedArea>
    }
    return (
        <FlexContainerLayout
            footer={
                <Button type="primary" disabled={!permission.canAdd} onClick={onCreateNewKey} data-testid={CypressTestIds.SYSTEM_KEYS_LIST_ADD_BUTTON}>
                    <PlusOutlined /> Add Key
                </Button>
            }
        >
            <Table
                size="small"
                rowKey="keyId"
                dataSource={keyList}
                pagination={false}
                className="flex size-full flex-1 flex-col [&_thead]:sticky [&_thead]:top-0 [&_thead]:z-10 [&_thead]:bg-header-footer [&_thead]:text-header-footer"
                data-testid={CypressTestIds.SYSTEM_KEYS_LIST_TABLE}
            >
                <Column
                    width="6em"
                    render={(text, record) => (
                        <>
                            <Tooltip title='Edit Key'>
                                <FontAwesomeIcon icon={faPencil} className={permission.canEdit ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"} onClick={() => permission.canEdit ? onEditKey(record.keyId) : null} data-testid={CypressTestIds.SYSTEM_KEYS_LIST_EDIT_BUTTON} /></Tooltip>
                            <Tooltip title='View Key'> <FontAwesomeIcon icon={faEye} className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"} onClick={() => permission.canView ? onViewKey(record.keyId) : null} data-testid={CypressTestIds.SYSTEM_KEYS_LIST_VIEW_BUTTON} /></Tooltip>
                            <Tooltip title='View Key History'>  <FontAwesomeIcon icon={faClockRotateLeft} className={permission.canView ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"} onClick={() => permission.canView ? onShowHistory(record.keyId) : null} data-testid={CypressTestIds.SYSTEM_KEYS_LIST_HISTORY_BUTTON} /></Tooltip>
                        </>
                    )}
                />
                <Column
                    title="Name"
                    dataIndex="name"
                    key="name"
                    ellipsis={{ showTitle: false }}
                    render={(text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>}
                />
                <Column
                    title="Description"
                    dataIndex="description"
                    key="description"
                    ellipsis={{ showTitle: false }}
                    render={(text) => <Tooltip placement="topLeft" title={text}>{text}</Tooltip>}
                />
                <Column
                    title="Type"
                    dataIndex="type"
                    key="type"
                    ellipsis={{ showTitle: false }}
                    render={(text) => <Tooltip placement="topLeft" title={keyTypesMap[text] || text}>{keyTypesMap[text] || text}</Tooltip>}
                />
                <Column
                    width="6em"
                    render={(text, record) => (
                        <Tooltip title="Delete Key">
                            <FontAwesomeIcon icon={faTrashCan} className={permission.canDelete ? "action-cursor text-blue-500" : "text-gray-400 opacity-45"} onClick={() => permission.canDelete ? onDeleteKey(record) : null} data-testid={CypressTestIds.SYSTEM_KEYS_LIST_DELETE_BUTTON} />
                        </Tooltip>
                    )}
                />
            </Table>
        </FlexContainerLayout>
    );
};

export default KeysList;
